// The funnel in a table header: filled when the column has a filter in force, opens the
// column's FilterPopover under it. The header is the control, as the spreadsheet's is. The
// button is the popover's invoker (`popoverTarget`): the browser shows and hides the popover on
// its clicks and exempts it from light dismiss, so a second click closes the popover instead of
// dismissing and reopening it in one press. `open` follows what the browser did.

import { useId, useRef, useState } from 'react';

import Icon from '../ui/Icon.jsx';
import FilterPopover from './FilterPopover.jsx';

export default function ColumnFilter({ leg, column, query, url, onFilter }) {
  const id = useId();
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const active = Boolean(query.filters[column.key]);

  return (
    <>
      <button
        ref={anchorRef}
        type="button"
        className={`icon-button funnel${active ? ' active' : ''}`}
        aria-label={`Filter ${column.label}`}
        aria-haspopup="dialog"
        aria-expanded={open}
        title={`Filter ${column.label}${active ? ' (in force)' : ''}`}
        popoverTarget={id}
      >
        <Icon name="funnel" />
      </button>
      <FilterPopover id={id} open={open} leg={leg} column={column}
                     search={url.filterSearch(query)} initial={query.filters[column.key]}
                     anchorRef={anchorRef} onToggle={setOpen}
                     onCommit={(key, values) => { setOpen(false); onFilter(key, values); }} />
    </>
  );
}
